import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";

interface ExitModeDialogProps {
  open: boolean;
  modeName: string;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ExitModeDialog({
  open,
  modeName,
  onClose,
  onConfirm,
}: ExitModeDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Switch to manual control?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          If you switch to manual control, you will lose access to the focused
          <em> {modeName}</em> analysis. This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained" color="error" autoFocus>
          Switch
        </Button>
      </DialogActions>
    </Dialog>
  );
}
